<template>
  <page-outline :title="$t('acceptance.rules_params')">
    <template slot="pageContent">
      <div class="listPage" style="overflow:hidden;">
        <div class="ml-3 mr-2">
          <label class="cursor" title="Saisissez un nombre compris entre 0 et 400 pour déterminer à partir de quand votre résultat de vérification sera concidéré valide" ><u>Comment ça marche ?</u> <i class="fa-light fa-info-circle text-info"></i></label>
          <b-row>
            <b-col class="form-group">
              <b-form-group :label="$t('verifications.lblSIRET')" label-for="bg-siret">
              <b-input-group>
                <b-form-input isMandatory
                id="bg-siret"
                v-model="siret_score"
                type="range"
                number
                min="0"
                max="400"
                step="1">
                </b-form-input>
                <b-input-group-append is-text class="text-monospace">
                  {{ siret_score }}
                </b-input-group-append>
              </b-input-group>
              <div class="mt-2 cursor" @click="changeVal('siret_req')">
                <i :class="siret_req == 1 ? 'fa-duotone fa-toggle-large-on' : 'fa-duotone fa-toggle-large-off text-muted'" style="font-size:17px"></i><span :class="siret_req == 1 ? 'font-weight-bold' : 'text-muted'">&nbsp;{{ $t('errors.mandatory')}}</span>
              </div>
              </b-form-group>
            </b-col>
            <b-col class="form-group">
              <b-form-group :label="$t('verifications.lblSIREN')" label-for="bg-siren">
              <b-input-group>
                <b-form-input isMandatory
                id="bg-siren"
                v-model="siren_score"
                type="range"
                number
                min="0"
                max="400"
                step="1">
                </b-form-input>
                <b-input-group-append is-text class="text-monospace">
                  {{ siren_score }}
                </b-input-group-append>
              </b-input-group><div class="mt-2 cursor" @click="changeVal('siren_req')">
                <i :class="siren_req == 1 ? 'fa-duotone fa-toggle-large-on' : 'fa-duotone fa-toggle-large-off text-muted'" style="font-size:17px"></i><span :class="siren_req == 1 ? 'font-weight-bold' : 'text-muted'">&nbsp;{{ $t('errors.mandatory')}}</span>
              </div>
              </b-form-group>
            </b-col>
            <b-col class="form-group">
              <b-form-group :label="$t('common.social_reason')" label-for="bg-social">
              <b-input-group>
                <b-form-input isMandatory
                id="bg-social"
                v-model="social_reason_score"
                type="range"
                number
                min="0"
                max="400"
                step="1">
                </b-form-input>
                <b-input-group-append is-text class="text-monospace">
                  {{ social_reason_score }}
                </b-input-group-append>
              </b-input-group>
              <div class="mt-2 cursor" @click="changeVal('social_reason_req')">
                <i :class="social_reason_req == 1 ? 'fa-duotone fa-toggle-large-on' : 'fa-duotone fa-toggle-large-off text-muted'" style="font-size:17px"></i><span :class="social_reason_req == 1 ? 'font-weight-bold' : 'text-muted'">&nbsp;{{ $t('errors.mandatory')}}</span>
              </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="form-group">
              <b-form-group :label="$t('suppliers.legal_status')" label-for="bg-legal">
              <b-input-group>
                <b-form-input isMandatory
                id="bg-legal"
                v-model="legal_form_score"
                type="range"
                number
                min="0"
                max="400"
                step="1">
                </b-form-input>
                <b-input-group-append is-text class="text-monospace">
                  {{ legal_form_score }}
                </b-input-group-append>
              </b-input-group>
              <div class="mt-2 cursor" @click="changeVal('legal_form_req')">
                <i :class="legal_form_req == 1 ? 'fa-duotone fa-toggle-large-on' : 'fa-duotone fa-toggle-large-off text-muted'" style="font-size:17px"></i><span :class="legal_form_req == 1 ? 'font-weight-bold' : 'text-muted'">&nbsp;{{ $t('errors.mandatory')}}</span>
              </div>
              </b-form-group>
            </b-col>
            <b-col class="form-group">
              <b-form-group :label="$t('common.dt_crtn')" label-for="bg-date">
              <b-input-group>
                <b-form-input isMandatory
                id="bg-date"
                v-model="registration_date_score"
                type="range"
                number
                min="0"
                max="400"
                step="1">
                </b-form-input>
                <b-input-group-append is-text class="text-monospace">
                  {{ registration_date_score }}
                </b-input-group-append>
              </b-input-group>
              <div class="mt-2 cursor" @click="changeVal('registration_date_req')">
                <i :class="registration_date_req == 1 ? 'fa-duotone fa-toggle-large-on' : 'fa-duotone fa-toggle-large-off text-muted'" style="font-size:17px"></i><span :class="registration_date_req == 1 ? 'font-weight-bold' : 'text-muted'">&nbsp;{{ $t('errors.mandatory')}}</span>
              </div>
              </b-form-group>
            </b-col>
            <b-col class="form-group">
              <b-form-group :label="$t('suppliers.core_business')" label-for="bg-naf">
              <b-input-group>
                <b-form-input isMandatory
                id="bg-naf"
                v-model="naf_code_score"
                type="range"
                number
                min="0"
                max="400"
                step="1">
                </b-form-input>
                <b-input-group-append is-text class="text-monospace">
                  {{ naf_code_score }}
                </b-input-group-append>
              </b-input-group>
              <div class="mt-2 cursor" @click="changeVal('naf_code_req')">
                <i :class="naf_code_req == 1 ? 'fa-duotone fa-toggle-large-on' : 'fa-duotone fa-toggle-large-off text-muted'" style="font-size:17px"></i><span :class="naf_code_req == 1 ? 'font-weight-bold' : 'text-muted'">&nbsp;{{ $t('errors.mandatory')}}</span>
              </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="form-group">
              <b-form-group :label="$t('common.adrs')" label-for="bg-street">
              <b-input-group>
                <b-form-input isMandatory
                id="bg-street"
                v-model="street_name_score"
                type="range"
                number
                min="0"
                max="400"
                step="1">
                </b-form-input>
                <b-input-group-append is-text class="text-monospace">
                  {{ street_name_score }}
                </b-input-group-append>
              </b-input-group>
              <div class="mt-2 cursor" @click="changeVal('street_name_req')">
                <i :class="street_name_req == 1 ? 'fa-duotone fa-toggle-large-on' : 'fa-duotone fa-toggle-large-off text-muted'" style="font-size:17px"></i><span :class="street_name_req == 1 ? 'font-weight-bold' : 'text-muted'">&nbsp;{{ $t('errors.mandatory')}}</span>
              </div>
              </b-form-group>
            </b-col>
            <b-col class="form-group">
              <b-form-group :label="$t('common.zp_code')" label-for="bg-zip">
              <b-input-group>
                <b-form-input isMandatory
                id="bg-zip"
                v-model="zipcode_score"
                type="range"
                number
                min="0"
                max="400"
                step="1">
                </b-form-input>
                <b-input-group-append is-text class="text-monospace">
                  {{ zipcode_score }}
                </b-input-group-append>
              </b-input-group>
              <div class="mt-2 cursor" @click="changeVal('zipcode_req')">
                <i :class="zipcode_req == 1 ? 'fa-duotone fa-toggle-large-on' : 'fa-duotone fa-toggle-large-off text-muted'" style="font-size:17px"></i><span :class="zipcode_req == 1 ? 'font-weight-bold' : 'text-muted'">&nbsp;{{ $t('errors.mandatory')}}</span>
              </div>
              </b-form-group>
            </b-col>
            <b-col class="form-group">
              <b-form-group :label="$t('common.cty')" label-for="bg-city">
              <b-input-group>
                <b-form-input isMandatory
                id="bg-city"
                v-model="city_score"
                type="range"
                number
                min="0"
                max="400"
                step="1">
                </b-form-input>
                <b-input-group-append is-text class="text-monospace">
                  {{ city_score }}
                </b-input-group-append>
              </b-input-group>
              <div class="mt-2 cursor" @click="changeVal('city_req')">
                <i :class="city_req == 1 ? 'fa-duotone fa-toggle-large-on' : 'fa-duotone fa-toggle-large-off text-muted'" style="font-size:17px"></i><span :class="city_req == 1 ? 'font-weight-bold' : 'text-muted'">&nbsp;{{ $t('errors.mandatory')}}</span>
              </div>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <br>
        <b-row>
          <b-col v-if="!method" cols="2" offset="10" class="form-group">
            <b-button variant="primary"
              size="lg"
              @click="addVerif()">
              {{ $t('common.sve') }}
            </b-button>
          </b-col>
          <b-col v-if="method" cols="2" offset="8" class="form-group">
            <b-button class="btn"
            size="lg"
            @click="deleteVerif(id)">
            {{ $t('common.del_label') }}
          </b-button>
        </b-col>
        <b-col v-if="method" cols="2" class="form-group">
          <b-button variant="primary"
          size="lg"
            @click="updateVerif()">
            {{ $t('Enregistrer les modifications') }}
          </b-button>
        </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import pageOutline from '@/components/common/PageOutline.vue'
// import {loadPage} from '@/helpers/routing'
import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'AddNote',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-accordion': FormAccordion,
    'page-outline': pageOutline
  },
  props: {
  },
  data () {
    return {
      // comp_state: '',
      // etab_state: '',
      // activity: '',
      // legal_process: '',
      // tva: '',
      // inscription: '',
      // status: '',
      // stability: '',
      siren_score: '',
      siret_score: '',
      legal_form_score: '',
      social_reason_score: '',
      registration_date_score: '',
      naf_code_score: '',
      street_name_score: '',
      zipcode_score: '',
      city_score: '',
      siren_req: 0,
      siret_req: 0,
      legal_form_req: 0,
      social_reason_req: 0,
      registration_date_req: 0,
      naf_code_req: 0,
      street_name_req: 0,
      zipcode_req: 0,
      city_req: 0,
      method: false,
      id: ''
    }
  },
  created () {
    this.getVerif()
  },
  methods: {
    changeVal (val) {
      if (this[val] === 0) {
        this[val] = 1
      } else {
        this[val] = 0
      }
    },
    getVerif () {
      // if get empty then method = true
      let that = this
      that.$engine.services.suppliers.getKYCScores()
      .then(resp => {
        if (Object.keys(resp.data.KYCScores).length === 0) {
          this.method = false
        } else {
          this.method = true
          this.makeArg(resp.data.KYCScores)
        }
      })
      .catch(e => {
        errorMessageAlert(e, this, this.$i18n)
      })
    },
    updateVerif () {
      let that = this
      that.$engine.services.suppliers.updateKYCScores(
        this.id,
        this.siren_score,
        this.siret_score,
        this.legal_form_score,
        this.social_reason_score,
        this.registration_date_score,
        this.naf_code_score,
        this.street_name_score,
        this.zipcode_score,
        this.city_score,
        this.siren_req,
        this.siret_req,
        this.legal_form_req,
        this.social_reason_req,
        this.registration_date_req,
        this.naf_code_req,
        this.street_name_req,
        this.zipcode_req,
        this.city_req
      )
      .then(resp => {
        this.getVerif()
      })
      .catch(e => {
        errorMessageAlert(e, this, this.$i18n)
      })
    },
    addVerif () {
      let that = this
      that.$engine.services.suppliers.createKYCScores(
        this.siren_score,
        this.siret_score,
        this.legal_form_score,
        this.social_reason_score,
        this.registration_date_score,
        this.naf_code_score,
        this.street_name_score,
        this.zipcode_score,
        this.city_score,
        this.siren_req,
        this.siret_req,
        this.legal_form_req,
        this.social_reason_req,
        this.registration_date_req,
        this.naf_code_req,
        this.street_name_req,
        this.zipcode_req,
        this.city_req
      )
      .then(resp => {
        this.getVerif()
      })
      .catch(e => {
        errorMessageAlert(e, this, this.$i18n)
      })
    },
    deleteVerif (id) {
      let that = this
      that.$engine.services.suppliers.deleteKYCScores(id)
      .then(
        this.deleteArg()
      )
      .catch(e => {
        errorMessageAlert(e, this, this.$i18n)
      })
    },
    makeArg (tab) {
      this.id = tab.id_kyc_acceptance_score
      this.siren_score = tab.siren_score
      this.siret_score = tab.siret_score
      this.legal_form_score = tab.legal_form_score
      this.social_reason_score = tab.social_reason_score
      this.registration_date_score = tab.registration_date_score
      this.naf_code_score = tab.naf_code_score
      this.street_name_score = tab.street_name_score
      this.zipcode_score = tab.zipcode_score
      this.city_score = tab.city_score
      this.siren_req = tab.siren_req
      this.siret_req = tab.siret_req
      this.legal_form_req = tab.legal_form_req
      this.social_reason_req = tab.social_reason_req
      this.registration_date_req = tab.registration_date_req
      this.naf_code_req = tab.naf_code_req
      this.street_name_req = tab.street_name_req
      this.zipcode_req = tab.zipcode_req
      this.city_req = tab.city_req
    },
    deleteArg (tab) {
      this.id = ''
      this.siren_score = ''
      this.siret_score = ''
      this.legal_form_score = ''
      this.social_reason_score = ''
      this.registration_date_score = ''
      this.naf_code_score = ''
      this.street_name_score = ''
      this.zipcode_score = ''
      this.city_score = ''
      this.siren_req = ''
      this.siret_req = ''
      this.legal_form_req = ''
      this.social_reason_req = ''
      this.registration_date_req = ''
      this.naf_code_req = ''
      this.street_name_req = ''
      this.zipcode_req = ''
      this.city_req = ''
    }
  }
}

</script>
